"use client";

// Last-resort boundary: catches throws in the root layout itself, where
// error.tsx can't. Must render its own <html>/<body> because it replaces the
// root layout entirely. Kept dependency-free (no Tailwind classes — the
// stylesheet may not have loaded if the layout crashed).

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global-error-boundary]", error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          display: "flex",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, sans-serif",
          background: "#fff",
          color: "#111827",
        }}
      >
        <div style={{ textAlign: "center", padding: 32, maxWidth: 420 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
            CRAYDL hit an unexpected error
          </h2>
          <p style={{ fontSize: 14, color: "#4b5563", marginBottom: 16 }}>
            Reloading usually fixes this.
            {error.digest ? ` Reference: ${error.digest}.` : ""}
          </p>
          <button
            onClick={reset}
            style={{
              padding: "8px 16px",
              background: "#5e5148", // brand-600
              color: "#fff",
              fontSize: 14,
              fontWeight: 500,
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      </body>
    </html>
  );
}
